import React, { useEffect, useState } from 'react';

export default function SessionTimer({ state }) {
  const [seconds, setSeconds] = useState(0);
  const running = state !== 'paused';

  useEffect(() => {
    if (!running) return undefined;
    const timer = setInterval(() => {
      setSeconds((prev) => prev + 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [running]);

  const pad = (value) => String(value).padStart(2, '0');
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;
  const label = hours > 0 ? `${pad(hours)}:${pad(minutes)}:${pad(secs)}` : `${pad(minutes)}:${pad(secs)}`;

  return <span className="font-mono text-sm tabular-nums text-slate-500">{label}</span>;
}
